import { Trans, useTranslation } from "react-i18next";
import AboutBGLeft from "../../../../assets/images/body/about_bg_left.svg";
import AboutBGRight from "../../../../assets/images/body/about_bg_right.svg";
import AboutImage from "../../../../assets/images/body/about_img.jpg";
import { Title } from "../../../../components";
import { useLayout } from "../../../../context/LayoutContext";
import styles from "./style.module.scss";

const AboutSection = () => {
  const { getPadding } = useLayout();
  const { t } = useTranslation();
  return (
    <div
      className={styles.aboutContainer}
      style={{ paddingLeft: getPadding() }}
      id="about"
    >
      <Title
        text={t("about.title")}
        shadowText={t("about.shadow")}
        containerStyle={styles.aboutTitleContainer}
        // shadowStyle={styles.aboutTitleShadow}
        // titleStyle={styles.aboutTitle}
      />
      <div className={styles.subContainer}>
        <div className={styles.descContainer}>
          <text className={styles.title}>{t("about.subtitle")}</text>
          <text className={styles.desc}>
            <Trans i18nKey={"about.desc"} />
          </text>
        </div>
        <img src={AboutImage} alt={"about"} className={styles.aboutImage} />
      </div>
      <img src={AboutBGLeft} alt={"about"} className={styles.bgleft} />
      <img src={AboutBGRight} alt={"about"} className={styles.bgRight} />
    </div>
  );
};

export default AboutSection;
